const translations = {
  en: {
    galleryTitle: 'Mediterranean Fashion Week X Laurent',
    aboutText: 'During Mediterránea Fashion Week, designers present their latest collections through spectacular runway shows held in iconic locations throughout Valencia. Each show fuses fashion with art, architecture, music, and storytelling.',
    valenciaTitle: ['Valencia:', 'A Mediterranean', 'Fashion Hub'],
    valenciaLeft: [
      'Visitors and professionals will be able to enjoy:',
      'Fashion shows with international designers',
      'Fashion presentations and exhibitions',
      'Industry networking events',
      'Creative collaborations between artists and designers',
      'Conferences and roundtables on fashion trends',
    ],
    valenciaRight: 'With thousands of attendees at each edition, the event contributes to the international projection of the city while promoting the creativity of Mediterranean fashion.',
    inviteImgText: 'Be a part of Fashion Week',
    inviteP1: 'Mediterránea Fashion Week returns to Valencia this October, bringing together fashion, art, and cultural heritage in an inspiring fourth edition. The historic Exhibition Palace will once again be transformed into the iconic venue where creativity and craftsmanship take center stage, offering a platform that promotes and showcases both national and international designers.',
    inviteP2: "This season's fashion show schedule will feature renowned brands such as Devota & Lomba, Madame Sibarita, Maison Mesa, Leticia Valera and Miguel Llopis, along with international brands such as Souraya Sharoui, Anthias, Leffers, Ramelle and Duly Romero, reflecting the event's growing global reach and its commitment to innovative design.",
    partnersTitle: 'Partners',
    contTitle: 'CONTRIBUTORS',
    collabTitle: ['COLLABORATION', 'EVENTS'],
  },
  es: {
    galleryTitle: 'Semana de la Moda Mediterránea X Laurent',
    aboutText: 'Durante la Semana de la Moda Mediterránea, los diseñadores presentan sus últimas colecciones a través de espectaculares desfiles celebrados en lugares icónicos de Valencia. Cada desfile fusiona la moda con el arte, la arquitectura, la música y la narrativa.',
    valenciaTitle: ['Valencia:', 'Un Hub de Moda', 'Mediterránea'],
    valenciaLeft: [
      'Los visitantes y profesionales podrán disfrutar de:',
      'Desfiles de moda con diseñadores internacionales',
      'Presentaciones y exposiciones de moda',
      'Eventos de networking del sector',
      'Colaboraciones creativas entre artistas y diseñadores',
      'Conferencias y mesas redondas sobre tendencias de moda',
    ],
    valenciaRight: 'Con miles de asistentes en cada edición, el evento contribuye a la proyección internacional de la ciudad mientras promueve la creatividad de la moda mediterránea.',
    inviteImgText: 'Sé parte de la Semana de la Moda',
    inviteP1: 'La Semana de la Moda Mediterránea regresa a Valencia este octubre, reuniendo moda, arte y patrimonio cultural en una inspiradora cuarta edición. El histórico Palacio de Exposiciones se transformará una vez más en el icónico escenario donde la creatividad y la artesanía son protagonistas.',
    inviteP2: 'El programa de desfiles de esta temporada contará con marcas reconocidas como Devota & Lomba, Madame Sibarita, Maison Mesa, Leticia Valera y Miguel Llopis, junto con marcas internacionales como Souraya Sharoui, Anthias, Leffers, Ramelle y Duly Romero.',
    partnersTitle: 'Patrocinadores',
    contTitle: 'COLABORADORES',
    collabTitle: ['EVENTOS DE', 'COLABORACIÓN'],
  },
};

export default translations;